import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import { useAppLocation } from '@src/hooks/utils/useAppLocation';
import LinkItem from './LinkItem';
import { LoggedInClient } from '../..';
import { receiverMenuData, remittanceMenuData, senderMenuData } from '../../data/dashboardData';
import { getActiveLink } from '../../utils/getActiveLink';
import { useAccount } from '@src/contexts';

interface Props {
  client?: LoggedInClient;
}

const Aside = ({ client }: Props) => {
  const location = useAppLocation();
  const { isRemittanceBusiness } = useAccount();

  const displayedMenuData = isRemittanceBusiness
    ? remittanceMenuData
    : client === 'sender'
    ? senderMenuData
    : receiverMenuData;
  return (
    <Box
      as="aside"
      className="ss-w-max ss-h-max ss-hidden lg:ss-block lg:ss-w-[250px] xl:ss-w-[300px] ss-sticky ss-top-30 ss-bg-white ss-py-14 ss-px-5 ss-rounded-b-lg">
      <Box className="ss-flex ss-flex-col ss-gap-2">
        {displayedMenuData.map((item) => (
          <LinkItem key={item.label} active={getActiveLink(item.to, location.pathname)} {...item} />
        ))}
      </Box>
    </Box>
  );
};

export default Aside;
